/* eslint-disable @typescript-eslint/no-unused-expressions */
import { notification } from 'antd'
import { useMutation, useQueryClient } from 'react-query'
import { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { QUERY_KEYS } from '@api'
import { TicketNotifContext } from '@contexts'

import { TicketsApi } from './api'

const useTickets = () => {
  const [isAcceptTicketModalOpen, setIsAcceptTicketModalOpen] = useState(false)
  const [isHideTicketModalOpen, setIsHideTicketModalOpen] = useState(false)
  const [isDeclineTicketModalOpen, setIsDeclineTicketModalOpen] = useState(false)
  const [isChangeCarrierModalOpen, setIsChangeCarrierModalOpen] = useState(false)

  const queryClient = useQueryClient()
  const ticketNotification = useContext(TicketNotifContext)

  const { t } = useTranslation()

  const onAcceptTicketSuccess = () => {
    notification.success({
      message: [
        `Ticket ID ${ticketNotification.state} `,
        t('tpl_router.tpl_dashboard.accept_decline_notification.accept'),
      ],
    })
    setIsAcceptTicketModalOpen(false)
    queryClient.invalidateQueries(QUERY_KEYS.TICKETS)
    queryClient.invalidateQueries(QUERY_KEYS.PENDINGS)
  }
  const onDeclineTicketSuccess = () => {
    notification.success({
      message: [
        `Ticket ID ${ticketNotification.state} `,
        t('tpl_router.tpl_dashboard.accept_decline_notification.decline'),
      ],
    })
    setIsDeclineTicketModalOpen(false)
    queryClient.invalidateQueries(QUERY_KEYS.TICKETS)
  }

  const onManualAssignSuccess = () => {
    notification.success({
      message: 'Carrier asignado con éxito',
    })
    setIsChangeCarrierModalOpen(false)
    queryClient.invalidateQueries(QUERY_KEYS.TICKETS)
  }

  const onAcceptTicketError = () => {
    notification.error({
      message: 'Error al aceptar la solicitud',
    })
  }

  const onDeclineTicketError = () => {
    notification.error({
      message: 'Error al rechazar la solicitud',
    })
  }

  const onManualAssignError = () => {
    notification.error({
      message: 'Error al cambiar el carrier',
    })
  }

  const { mutate: acceptTicket, isLoading: acceptTicketLoading } = useMutation(
    TicketsApi.acceptTicket,
    {
      onSuccess: onAcceptTicketSuccess,
      onError: onAcceptTicketError,
    },
  )

  const { mutate: declineTicket, isLoading: declineTicketLoading } = useMutation(
    TicketsApi.declineTicket,
    {
      onSuccess: onDeclineTicketSuccess,
      onError: onDeclineTicketError,
    },
  )

  const { mutate: changeTicket, isLoading: changeTicketLoading } = useMutation(
    TicketsApi.changeTicket,
    {
      onSuccess: () => {
        queryClient.refetchQueries(QUERY_KEYS.TICKETS)
      },
      onError: () => {
        notification.error({
          message: t('globals.validation_error_time'),
        })
      },
    },
  )

  const { mutate: manualAssign, isLoading: manualAssignLoading } = useMutation(
    TicketsApi.manualAssign,
    {
      onSuccess: onManualAssignSuccess,
      onError: onManualAssignError,
    },
  )

  return {
    acceptTicket,
    acceptTicketLoading,
    declineTicket,
    declineTicketLoading,
    manualAssign,
    manualAssignLoading,
    changeTicket,
    changeTicketLoading,
    isAcceptTicketModalOpen,
    isHideTicketModalOpen,
    setIsHideTicketModalOpen,
    setIsAcceptTicketModalOpen,
    isDeclineTicketModalOpen,
    setIsDeclineTicketModalOpen,
    isChangeCarrierModalOpen,
    setIsChangeCarrierModalOpen,
  }
}

export { useTickets }
